<template>
	<div>
		<nav-bar></nav-bar>
		<con-tab></con-tab>
		<div class="bg">
			<div class="banxin ">
				<div class="tongbox">
					<div class="tongleft">
						<div class="duantop">
							<img :src="info.image" class="duanpic" alt="" />
							<div class="duanyou">
								<div class="duantitle oneline">
									{{info.title}}
								</div>
								<div class="duanul">
									<div class="duanli">
										仪器编号：
										<span>{{info.no}}</span>
									</div>
									<div class="duanli">
										是否出具检测报告：
										<span>{{info.is_report}}</span>
									</div>
									<div class="duanli">
										仪器分类：
										<span>{{info.category.title}}</span>
									</div>
									<div class="duanli">
										所在单位：
										<span>{{info.company}}</span>
									</div>
									<div class="duanli">
										仪器分类编码：
										<span>{{info.category.no}}</span>
									</div>
									<div class="duanli">
										主要测试和研究领域：
										<span>{{info.research_name}}</span>
									</div>
								</div>
							</div>
						</div>
						
						<div class="jibenbox">
							<div class="jibentop">
								<div class="jibentitle">
									基本信息
								</div>
							</div>
							<div class="jibennei">
								<div class="jibg">
									<div class="jili">
										<div class="jione">
											<div class="yiqitxt">
												仪器认证情况：
												<span>
													{{info.renzheng}}
												</span>
											</div>
										</div>
										<div class="jitwo">
											<div class="yiqitxt">
												参考收费标准：
												<span>
													{{info.shoufei}}
												</span>
											</div>
										</div>
										<div class="jisan">
											<div class="yiqitxt">
												仪器原值：
												<span>
													{{info.yuanzhi}}
												</span>
											</div>
										</div>
									</div>
									
									<div class="jili">
										<div class="jione">
											<div class="yiqitxt">
												启用日期：
												<span>
													{{info.qiyong}}
												</span>
											</div>
										</div>
										<div class="jitwo">
											<div class="yiqitxt">
												产地国别：
												<span>
													{{info.guobie}}
												</span>
											</div>
										</div>
										
									</div>
									
									<div class="jili">
										<div class="jione">
											<div class="yiqitxt">
												仪器英文名称：
												<span>
													{{info.en_title}}
												</span>
											</div>
										</div>
										<div class="jitwo">
											<div class="yiqitxt">
												仪器设备类别：
												<span>
													{{info.shebei}}
												</span>
											</div>
										</div>
									</div>
									
									<div class="jili">
										<div class="jione">
											<div class="yiqitxt">
												仪器生产厂商：
												<span>
													{{info.changshang}}
												</span>
											</div>
										</div>
									</div>
								</div>
								<div class="guitxt">
									仪器规格：
									<span>{{info.guige}}</span>
								</div>
								<div class="guitxt">
									主要技术指标：
									<span>
										{{info.zhibiao}}
									</span>
								</div>
								
								<div class="guitxt">
									仪器主要用途：
									<span>{{info.yongtu}}</span>
								</div>
								
							</div>
						</div>
						
						
						<div class="jibenbox">
							<div class="jibentop">
								<div class="jibentitle">
									仪器对外服务信息
								</div>
							</div>
							<div class="jibennei">
								<div class="jibg">
									<div class="jili">
										<div class="jione">
											<div class="yiqitxt">
												仪器安放城市：
												<span>
													{{info.city}}
												</span>
											</div>
										</div>
										<div class="jisi">
											<div class="yiqitxt">
												仪器所在地址:
												<span>
													{{info.address}}
												</span>
											</div>
										</div>
										
									</div>
									
									<div class="jili">
										<div class="jione">
											<div class="yiqitxt">
												联系人电话：
												<span>
													{{info.tel}}
												</span>
											</div>
										</div>
										<div class="jisan">
											<div class="yiqitxt">
												仪器联系人：
												<span>
													{{info.name}}
												</span>
											</div>
										</div>
										<div class="jitwo">
											<div class="yiqitxt">
												电子邮箱：
												<span>
													{{info.email}}
												</span>
											</div>
										</div>
									
									</div>
									
									<div class="jili">
										<div class="jibai">
											<div class="yiqitxt">
												对外服务时间：
												<span>
													{{info.duiwai}}
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					
					<div class="tongright">
						<div class="hottop">
							<img src="../../assets/img/images/hot_03.png" class="firepic" alt="" />
							<div class="hottitle">
								热门仪器
							</div>
							<div class="chengline"></div>
						</div>
						<div class="zhenbox" v-for="(item,index) in shiList" @click="goTodetail(item.id)">
							<img :src="item.image" class="zhenpic" alt="" />
							<div class="zhenyou">
								<div class="zhentitle oneline">
									{{item.title}}
								</div>
								<div class="dantxt oneline">
									所在单位：
									<span>{{item.company}}</span>
								</div>
								<div class="dantxt oneline">
									是否出具检测报告：
									<span>{{item.is_report}}</span>
								</div>
							</div>
							
						</div>
					</div>
				</div>
			</div>
		</div>
		<tab-bar></tab-bar>
	</div>
</template>

<script>
	import TabBar from "../../components/common/TabBar";
	import ConTab from "../../components/common/ConTab";
	import NavBar from '../../components/common/NavBar';
	import NeedJc from "./base/NeedJc";
	import { qixieDetail } from "@/common/js/api";
	import {shiyan_list} from '../common/js/api';
	export default {
		name: "Needjc",
		components: {
			NavBar,
			NeedJc,
			ConTab,
			TabBar
		},
		data() {
			return {
				id:'',
				info:{},
				shiList:[]
			};
		},
		created() {
			this.id = this.$route.query.id;
			this.getDetail()
			this.shiyan()
		},
		methods: {
			shiyan() {
				shiyan_list({})
					.then(res => {
						this.shiList = res.data
					})
					.catch(err => {});
			},
			getDetail() {
				qixieDetail({
					id:this.id
				})
					.then(res => {
						console.log(res,'=============')
						this.info= res.data
					})
					.catch(err => {});
			},
		},
		mounted() {},
	}
</script>

<style scoped lang="less">
	.bg{
		background-color: #f6f6f6;
		margin-top: 136px;
	}
	.tongbox {
		padding: 20px 0 60px;
		display: flex;
		align-items: flex-start;
		justify-content: space-between;

		.tongleft {
			width: 1025px;
			flex-shrink: 0;
			.duantop{
				background-color: #ffffff;
				display: flex;
				align-items: center;
				padding: 40px;
				margin-bottom: 20px;
				.duanpic{
					width: 275px;
					height: 195px;
					flex-shrink: 0;
				}
				.duanyou{
					padding-left: 30px;
					flex-grow: 1;
					.duantitle{
						font-size: 28px;
						color: #222222;
						font-weight: bold;
					}
					.duanul{
						display: flex;
						align-items: center;
						flex-wrap: wrap;
						.duanli{
							width: 40%;
							padding-top: 35px;
							font-size: 18px;
							color: #888888;
							span{
								font-size: 18px;
								color: #555555;
							}
						}
						.duanli:nth-child(2n){
							width: 60%;
						}
					}
				}
			}
			.jibenbox{
				background-color: #ffffff;
				padding-bottom: 25px;
				margin-bottom: 20px;
				.jibentop{
					display: flex;
					align-items: center;
					height: 60px;
					padding: 0 35px;
					border-bottom: 1px solid #eeeeee;
					.jibentitle{
						font-size: 24px;
						color: #0289f4;
						line-height: 57px;
						font-weight: bold;
						border-bottom: 2px solid #0289f4;
					}
				}
				
				.jibennei{
					padding: 25px 35px 0;
					.jibg{
						background-image: linear-gradient(#fbfdff,#f2f9fe);
						padding: 0 20px;
						margin-bottom: 20px;
						.jili:last-child{
							border: none;
						}
						.jili{
							padding: 20px 0;
							display: flex;
							align-items: flex-start;
							border-bottom: 1px solid #eeeeee;
							.jibai{
								width: 100%;
							}
							.jione{
								width: 40%;
							}
							.jitwo{
								width: 35%;
							}
							.jisan{
								width: 25%;
							}
							.jisi{
								width: 60%;
							}
							.yiqitxt{
								font-size: 16px;
								color: #222222;
								line-height: 25px;
								font-weight: bold;
								span{
									font-size: 16px;
									color: #222222;
									font-weight: 400;
								}
							}
						}
					}
					.guitxt{
						font-size: 18px;
						color: #222222;
						padding-bottom: 10px;
						span{
							font-size: 18px;
							color: #888888;
							font-weight: 400;
						}
					}
				}
			}
		}
		.tongright{
			width: 335px;
			padding: 27px 20px 40px;
			background-color: #ffffff;
			.hottop{
				display: flex;
				align-items: center;
				padding-bottom: 10px;
				border-bottom: 3px solid #f5f5f5;
				position: relative;
				.firepic{
					width: 24px;
					height: 30px;
				}
				.hottitle{
					font-size: 20px;
					color: #222222;
					font-weight: bold;
					padding-left: 10px;
				}
				.chengline{
					height: 3px;
					background-color: #ff4200;
					position: absolute;
					left: 0;
					bottom: -3px;
					width: 120px;
				}
			}
			.zhenbox{
				cursor: pointer;
				display: flex;
				align-items: center;
				padding-top: 40px;
				.zhenpic{
					width: 110px;
					height: 78px;
					flex-shrink: 0;
				}
				.zhenyou{
					padding-left: 14px;
					flex-grow: 1;
					.zhentitle{
						font-size: 15px;
						max-width: 150px;
						color: #222222;
					}
					.dantxt{
						font-size: 14px;
						color: #888888;
						max-width: 150px;
						padding-top: 16px;
						span{
							font-size: 14px;
							color: #222222;
						}
					}
				}
			}
			.zhenbox:hover{
				.zhentitle{
					color: #0289f4;
				}
			}
		}
	}

	.banxin {
		width: 1400px;
		margin: 0 auto;
	}
	@media screen and (max-width: 1200px) {
		.banxin{
			width: 98%;
			margin: 0 auto;
			display: block;
			overflow: hidden;
		}
		.tongbox .tongright{
			display: none;
		}
		.bg{
			margin-top: 15rem;
		}
		.tongbox .tongleft{
			width: 100%;
		}
		.tongbox .tongleft .duantop{
			padding: 2rem 1rem;
			align-items: flex-start;
		}
		.tongbox .tongleft .duantop .duanyou .duantitle{
			font-size: 1.8rem;
		}
		.tongbox .tongleft .duantop .duanyou .duanul .duanli{
			width: 100% !important;
		}
		.tongbox .tongleft .duantop .duanyou .duanul .duanli{
			font-size: 1.5rem;
			padding-top: 1rem;
			width: 100%;
		}
		.tongbox .tongleft .duantop .duanyou .duanul .duanli span{
			font-size: 1.5rem;
		}
		.tongbox .tongleft .duantop .duanpic{
			width: 17rem;
			height: auto;
		}
		.tongbox .tongleft .jibenbox .jibentop{
			height: 4.5rem;
		}
		.tongbox .tongleft .jibenbox .jibentop .jibentitle{
			font-size: 1.8rem;
			line-height: 4.5rem;
		}
		.tongbox .tongleft .jibenbox .jibennei .jibg .jili{
			flex-wrap: wrap;
		}
		.tongbox .tongleft .jibenbox .jibennei .jibg .jili .jione{
			width: 100%;
		}
		.tongbox .tongleft .jibenbox .jibennei .jibg .jili .jitwo{
			width: 100%;
		}
		.tongbox .tongleft .jibenbox .jibennei .jibg .jili .jisan{
			width: 100%;
		}
		.tongbox .tongleft .jibenbox .jibennei .jibg .jili .yiqitxt{
			font-size: 1.6rem;
			line-height: 3rem;
		}
		.tongbox .tongleft .jibenbox .jibennei .jibg .jili .yiqitxt span{
			font-size: 1.6rem;
		}
		.tongbox .tongleft .jibenbox .jibennei .guitxt{
			font-size: 1.6rem;
			padding-bottom: 1.5rem;
			line-height: 3rem;
		}
		.tongbox .tongleft .jibenbox .jibennei .guitxt span{
			font-size: 1.6rem;
		}
	}
</style>